<template>
    <div>
        <v-subheader>Manage</v-subheader>
            <v-list-item link :to="'/reservations/stats'">
              <v-list-item-icon>
                <v-icon>mdi-home-analytics</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Stats</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="'/reservations/audit'">
              <v-list-item-icon>
                <v-icon>mdi-google-analytics</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Audit Reservations</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="'/reservations/setup'">
              <v-list-item-icon>
                <v-icon>mdi-account-hard-hat</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Setup Requests</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="'/reservations/manage'">
              <v-list-item-icon>
                <v-icon>mdi-calendar-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Manage Reservations</v-list-item-title>
            </v-list-item>
            <v-divider class="mb-3 mt-2"></v-divider>
    </div>
</template>

<script>

export default {
  name: 'MitMenuManager',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
      return {
        buildings:[],
      }
  }
}
</script>

<style lang="scss" scoped>
</style>
